import { Notifications } from "@mui/icons-material";
import { Box, Grid, Skeleton, Pagination } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../Buttons/PrimaryButton";
import PagesCard from "./PagesCard";
import PagesService from "../../services/Pages.service";
import IPages from "../../types/Pages.type";

interface PagesListProps {
  button?: boolean;
  maxNotifications?: number;
}

const PagesList: React.FC<PagesListProps> = (props) => {
  const navigate = useNavigate();
  const [data, setData] = useState<IPages[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const pagesPerPage = 12;

  const maxPages = props.maxNotifications || data.length;

  const fetchNotifications = () => {
    setLoading(true);
    PagesService.getAll()
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching notifications:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchForRead = () => {
    PagesService.getAll()
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching notifications:", err);
      });
  };

  const displayedNotifications = data.slice(0, maxPages);

  if (props.maxNotifications) {
    return (
      <Box sx={{ margin: "auto" }}>
        <Grid container spacing={2}>
          {loading
            ? Array.from({ length: 6 }).map((_, index) => (
                <Grid item xs={12} sm={12} md={6} key={index}>
                  <Skeleton
                    sx={{ bgcolor: "grey.900" }}
                    animation="wave"
                    variant="rectangular"
                    width="100%"
                    height={150}
                  />
                </Grid>
              ))
            : displayedNotifications.map((page, index) => (
                <Grid item xs={12} sm={12} md={6} key={index}>
                  <PagesCard
                    refreshPage={fetchForRead}
                    id={page.id}
                    title={page.title}
                    websiteId={page.websiteId}
                    content={page.content}
                  />
                </Grid>
              ))}
        </Grid>

        {props.button && (
          <PrimaryButton
            icon={<Notifications />}
            onClick={() => navigate("/dashboard/pages")}
            title="További értesítések"
          />
        )}
      </Box>
    );
  }

  const indexOfLastNotification = currentPage * pagesPerPage;
  const indexOfFirstNotification =
    indexOfLastNotification - pagesPerPage;
  const currentNotifications = displayedNotifications.slice(
    indexOfFirstNotification,
    indexOfLastNotification
  );

  const totalPages = Math.ceil(
    displayedNotifications.length / pagesPerPage
  );

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };

  return (
    <Box sx={{ margin: "auto" }}>
      <Grid container spacing={2}>
        {loading
          ? Array.from({ length: 6 }).map((_, index) => (
              <Grid item xs={12} sm={12} md={6} key={index}>
                <Skeleton
                  sx={{ bgcolor: "grey.900" }}
                  animation="wave"
                  variant="rectangular"
                  width="100%"
                  height={150}
                />
              </Grid>
            ))
          : currentNotifications.map((page, index) => (
              <Grid item xs={12} sm={12} md={6} key={index}>
                <PagesCard
                  refreshPage={fetchForRead}
                  id={page.id}
                  websiteId={page.websiteId}
                  title={page.title}
                  content={page.content}
                />
              </Grid>
            ))}
      </Grid>

      <Box
        sx={{ display: "flex", justifyContent: "center", marginTop: "16px" }}
      >
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color="standard"
          size="small"
          disabled={loading}
        />
      </Box>

      {props.button && (
        <PrimaryButton
          icon={<Notifications />}
          onClick={() => navigate("/dashboard/notifications")}
          title="További értesítések"
        />
      )}
    </Box>
  );
};

export default PagesList;
